/* eslint-disable */
import errorReporter from '@app/errorReporter';
import fixWrapperHeight from '../../fixWrapperHeight';

angular
  .module('bb.network')
  .controller('ListingNetworkMapCtrl', ListingNetworkMapCtrl);

ListingNetworkMapCtrl.$inject = [
  '$scope',
  '$rootScope',
  '$resource',
  '$location',
  'NgMap',
  '$window',
  '$timeout',
  'LS',
  'ListingViewService',
  'ModalService',
];
function ListingNetworkMapCtrl(
  $scope,
  $rootScope,
  $resource,
  $location,
  NgMap,
  $window,
  $timeout,
  LS,
  ListingViewService,
  ModalService,
) {
  constructor();
  var redirectTimeout;

  LS.setData('listings', null);

  function constructor() {
    $scope.selectedShape = null;
    $scope.mobile = $window.innerWidth < 480;
    $scope.pageSize = 20;
    $scope.loading = true;
    $scope.totalListings = 0;
    $scope.manualSearch = false;
    $scope.savedNetworkSearches = [];
    $scope.initShapes = [];
    $scope.newShapes = [];
    $scope.search = {};
    $scope.selectedSavedSearch = {
      value: null,
    };
    getFavorites();
    getSavedNetworkSearches();
  }

  function setSearchParams(params) {
    $scope.search = {
      minPrice: Number(params.minPrice) || null,
      maxPrice: Number(params.maxPrice) || null,
      status: params.status || 'All',
      type: params.type || 'All',
      subtype: params.subtype || 'All',
      page: params.page && Number(params.page) > 0 ? Number(params.page) : 1,
      minBeds: Number(params.minBeds) || 0,
      minBaths: Number(params.minBaths) || 0,
      mclat: params.mclat || 43.64997065164351,
      mclng: params.mclng || -79.38560325927733,
      mzm: params.mzm || 8,
      mblatf: params.mblatf,
      mblatt: params.mblatt,
      mblngf: params.mblngf,
      mblngt: params.mblngt,
      polygons: params.polygons || '[]',
    };

    // Set zoom
    $scope.zoom = Number($scope.search.mzm);
    // Set center
    if ($scope.search.mclat && $scope.search.mclng) {
      $scope.latlng = new google.maps.LatLng(
        Number($scope.search.mclat),
        Number($scope.search.mclng),
      );
    }
    // Set shapes
    $scope.initShapes = [];
    JSON.parse(decodeURI($scope.search.polygons)).forEach(function (coords) {
      if (coords) {
        var path = coords.map(function (coord) {
          return { lat: coord[1], lng: coord[0] };
        });
        var polygon = new google.maps.Polygon({
          path: path,
          strokeColor: 'black',
          strokeWeight: 2,
          strokeOpacity: 0.8,
          clickable: true,
        });
        polygon.coords = coords;
        $scope.initShapes.push(polygon);
      }
    });
  }

  function getFavorites() {
    // get favorites
    var Favorites = $resource('/favorite');
    return Favorites.query().$promise.then(function (favorites) {
      $scope.favorites = favorites;
    });
  }

  function getSavedNetworkSearches() {
    var NetworkSearch = $resource('/network_search');
    return NetworkSearch.get().$promise.then(function (networkSearches) {
      $scope.savedNetworkSearches = networkSearches.data;
    });
  }

  function search(page) {
    $scope.search.page = page;
    // updating the location will search listings
    fetchMapData($scope.search);
  }

  function fetchMapData(searchParams) {
    setSearchParams(searchParams);
    getListings();
  }

  $scope.goToListing = function (id) {
    var width = $(window).width();
    // If mobile, redirect
    if (width < 700) {
      $location.path('listing/' + id + '/view');
    } else {
      ModalService.openNetworkModal(id).then(function (removed) {
        if (removed) getListings();
      });
    }
  };

  function removeShape(shape) {
    var shapeKey = '';
    Object.keys(shape).forEach(function (key) {
      if (key.match(/closure_uid_/)) {
        shapeKey = key + shape[key];
      }
    });

    // Check newShapes
    var newIndex = null;
    for (var i = 0; i < $scope.newShapes.length; i++) {
      var newShape = $scope.newShapes[i];
      Object.keys(newShape).forEach(function (key) {
        if (key.match(/closure_uid_/) && shapeKey === key + newShape[key]) {
          newIndex = i;
        }
      });
    }
    if (newIndex != null) {
      $scope.newShapes.splice(newIndex, 1);
    }

    // Check initShapes
    var initIndex = null;
    for (var i = 0; i < $scope.initShapes.length; i++) {
      var initShape = $scope.initShapes[i];
      Object.keys(initShape).forEach(function (key) {
        if (key.match(/closure_uid_/) && shapeKey === key + initShape[key]) {
          initIndex = i;
        }
      });
    }
    if (initIndex != null) {
      $scope.initShapes.splice(initIndex, 1);
    }
  }

  function toggleMarker(marker) {
    marker.open = !marker.open;

    // Change the position ever so slighty to trigger the marker to re-center itself on the right location
    marker.position[0] =
      marker.position[0] + (marker.open ? 0.000001 : -0.000001);
    marker.markerStyle = marker.open
      ? {
          'z-index': 999,
          width: '200px',
        }
      : {};
  }

  function setShapeColor(shape, color) {
    shape.set('strokeColor', color);
    shape.set('fillColor', color);
  }

  function clearSelection() {
    if ($scope.selectedShape) {
      $scope.selectedShape.setEditable(false);
      $scope.selectedShape.setDraggable(false);
      setShapeColor($scope.selectedShape, 'black');
      $scope.selectedShape = null;
    }
  }

  function shapeClicked(shape) {
    clearSelection();
    $scope.selectedShape = shape;
    // shape.setEditable(true);
    // shape.setDraggable(true);
    setShapeColor(shape, 'red');
    $scope.$apply();
  }

  function setSearchPolygons() {
    var newShapesCoords =
      $scope.newShapes.map(function (newShape) {
        return newShape.coords;
      }) || [];
    var initShapesCoords =
      $scope.initShapes.map(function (initShape) {
        return initShape.coords;
      }) || [];
    $scope.search.polygons = JSON.stringify(
      newShapesCoords.concat(initShapesCoords),
    );
  }

  function resetShape() {
    $scope.newShapes.forEach(function (newShape) {
      newShape.setMap(null);
    });
    $scope.initShapes.forEach(function (initShape) {
      initShape.setMap(null);
    });
    $scope.newShapes = [];
    $scope.initShapes = [];
  }

  $scope.selectShape = function (e) {
    // TODO: Might be legacy function
  };

  $scope.deleteSelectedShape = function () {
    removeShape($scope.selectedShape);
    $scope.selectedShape.setMap(null);
    $scope.selectedShape = null;
    setSearchPolygons();
    $scope.searchNetwork();
  };

  $scope.deleteShapes = function () {
    resetShape();
    setSearchPolygons();
    $scope.searchNetwork();
  };

  $scope.overlayCreated = function (e) {
    // Get the polygons
    var newShape = e.overlay;
    newShape.type = e.type;
    var coords = [];
    if (newShape.type === 'polygon') {
      // Polygon

      google.maps.event.addListener(newShape, 'click', function () {
        shapeClicked(newShape);
      });
      google.maps.event.addListener(newShape, 'insert_at', function () {
        // setSearchPolygons();
        // $scope.searchNetwork();
      });
      google.maps.event.addListener(newShape, 'remove_at', function () {
        // setSearchPolygons();
        // $scope.searchNetwork();
      });
      google.maps.event.addListener(newShape, 'set_at', function () {
        // setSearchPolygons();
        // $scope.searchNetwork();
      });

      coords = newShape
        .getPath()
        .getArray()
        .map(function (coord) {
          return [coord.lat(), coord.lng()];
        });
    } else if (newShape.type === 'rectangle') {
      // Rectangle
      google.maps.event.addListener(newShape, 'click', function () {
        shapeClicked(newShape);
      });

      var ne = newShape.getBounds().getNorthEast();
      var sw = newShape.getBounds().getSouthWest();
      coords.push([ne.lat(), sw.lng()]);
      coords.push([ne.lat(), ne.lng()]);
      coords.push([sw.lat(), ne.lng()]);
      coords.push([sw.lat(), sw.lng()]);
    }
    if (coords.length > 2) {
      newShape.coords = coords;
      $scope.newShapes.push(newShape);
      if (redirectTimeout) {
        $timeout.cancel(redirectTimeout);
      }
      redirectTimeout = $timeout(function () {
        setSearchPolygons();
        $scope.searchNetwork();
      }, 250);
    } else {
      // invalid shape
      e.overlay.setMap(null);
    }
  };

  $scope.mapInitialized = function (map) {
    fixWrapperHeight();

    $scope.initShapes.forEach(function (shape) {
      shape.setMap(map);
      google.maps.event.addListener(shape, 'click', function (event) {
        shapeClicked(shape);
      });
    });

    // setSearchParams sets $scope.latlng you must call
    // this before centering the map
    setSearchParams({});
    google.maps.event.trigger(map, 'resize');
    map.setZoom($scope.zoom);
    map.setCenter($scope.latlng);

    google.maps.event.addListenerOnce(map, 'tilesloaded', () => {
      $scope.mapLoaded = true;
      searchNetwork();
    });
  };

  $scope.loadSavedNetworkSearch = function () {
    $scope.newShapes.forEach(function (newShape) {
      if (newShape) {
        newShape.setMap(null);
      }
    });
    setSearchParams($scope.selectedSavedSearch.value);
    fetchMapData($scope.search);
  };

  $scope.searchChanged = function () {
    $scope.selectedSavedSearch.value = null;
  };

  $scope.saveSearch = function () {
    var NetworkSearch = $resource('/network_search');
    var networkSearch = new NetworkSearch($scope.search);

    swal(
      {
        title: 'Save Network Search',
        text: 'Save network search as:',
        type: 'input',
        showCancelButton: true,
        confirmButtonColor: '#62cb31',
        closeOnConfirm: false,
      },
      function (name) {
        if (name === false) return false;
        if (name === '') {
          swal.showInputError('Name required!');
          return false;
        }
        networkSearch.name = name;
        networkSearch.$save(function (networkSearch) {
          swal('Network Search Saved', '', 'success');
          getSavedNetworkSearches();
        });
      },
    );
  };

  $scope.closeListing = function (event, marker) {
    toggleMarker(marker);
    event.preventDefault();
    event.stopPropagation();
    return false;
  };

  $scope.listingClicked = function (event, marker) {
    if (marker.open) {
      // $location.path("listing/" + marker.id + "/view");
      $scope.goToListing(marker.id);
      return;
    }

    $scope.activeListing = marker.id;
    var combo =
      $('#network_pane').scrollTop() +
      $('#network-card-' + marker.id).offset().top -
      $('#network-card-' + marker.id).height();

    $('#network_pane').animate(
      {
        scrollTop: combo,
      },
      500,
    );

    for (var index in $scope.customMarkers) {
      var curMarker = $scope.customMarkers[index];
      if (curMarker.open && curMarker.id !== marker.id) {
        toggleMarker(curMarker);
      }
    }
    toggleMarker(marker);
  };

  function searchNetwork(page) {
    if (!$scope.mapLoaded) return;

    // init map
    NgMap.getMap('networkMap').then(function (map) {
      $scope.search.mclat = map.getCenter().lat(); // mclat = map center lat
      $scope.search.mclng = map.getCenter().lng(); // mclng = map center lng

      $scope.search.mzm = map.getZoom(); // mzm = map zoom
      $scope.search.mblatf = map.getBounds().getSouthWest().lat(); // blatf = map bound lat from
      $scope.search.mblatt = map.getBounds().getNorthEast().lat(); // blatt = map bound lat to
      $scope.search.mblngf = map.getBounds().getSouthWest().lng(); // mblngf = map bound lng from
      $scope.search.mblngt = map.getBounds().getNorthEast().lng(); // mblngt = map bound lng to

      search(page || 1);
    });
  }

  $scope.searchNetwork = searchNetwork;
  $scope.curListingId = undefined;

  $scope.openListingModal = function (id) {
    delete $scope.curListing;
    $scope.curListingId = id;
    ListingViewService.getListing(id).then(function (listing) {
      $scope.curListing = listing;
    });
    $('#listingModal').modal('toggle');
  };

  $scope.prevPage = function () {
    $scope.searchNetwork(Number($scope.search.page) - 1);
  };

  $scope.getPage = function (pageNumber) {
    $scope.searchNetwork(pageNumber);
  };

  $scope.zoomChanged = function () {
    if (!$scope.dataLoaded || $scope.loading) return;

    if (redirectTimeout) {
      $timeout.cancel(redirectTimeout);
    }

    $scope.search.page = 1;
    redirectTimeout = $timeout($scope.searchNetwork, 1000);
  };

  // Get listings
  function getListings() {
    $scope.loading = true;
    return NgMap.getMap('networkMap').then(function (map) {
      $scope.errorMessage = '';

      var Listing = $resource('/listing/network_map');
      Listing.get($scope.search)
        .$promise.then(function (data) {
          $scope.manualSearch = false;

          $scope.dataLoaded = true;
          $scope.listings = data.listings;
          var count = data.count;

          var listingIds = _.map(data.listings, '_id');
          $resource('/file/listings/all')
            .get({ listingIds: listingIds })
            .$promise.then(function (data) {
              $scope.listingImages = data;
            });

          $scope.listingRows = [];
          var currentRow = {
            listings: [],
          };

          for (var i = 0; i < $scope.listings.length; i++) {
            if (i % 2 === 0) {
              $scope.listingRows.push(currentRow);
              currentRow = {
                listings: [],
              };
            }

            currentRow.listings.push($scope.listings[i]);
          }

          if (currentRow.listings.length !== 0) {
            $scope.listingRows.push(currentRow);
          }

          var prevMarkers = _.clone($scope.customMarkers);
          prevMarkers = _.groupBy(prevMarkers, 'id');

          // populate markers
          $scope.customMarkers = [];
          _.each($scope.listings, function (listing) {
            // If we already had the listing, use the existing one
            if (prevMarkers[listing._id]) {
              $scope.customMarkers.push(prevMarkers[listing._id][0]);
            } else if (listing.coords) {
              $scope.customMarkers.push({
                position: [
                  listing.coords.coordinates[1],
                  listing.coords.coordinates[0],
                ],
                price: '$' + listing.list_price.formatMoney(0, '.', ','),
                style: getStyle(listing.status),
                id: listing._id,
                listing: listing,
              });
            }
          });

          // pagination
          $scope.pages = [];
          // Show maximum 5 pages including current page
          $scope.pageNumbers = [];
          var currentPage = parseInt($scope.search.page);
          $scope.totalListings = count;

          // Start of pagination
          for (
            var pageNumber = currentPage - 2;
            pageNumber <= currentPage + 2 &&
            pageNumber <= Math.ceil(count / $scope.pageSize);
            pageNumber++
          ) {
            if (pageNumber > 0) {
              $scope.pageNumbers.push(pageNumber);
            }
          }

          $scope.loading = false;
        })
        .catch(function (e) {
          errorReporter.error(e);
          $scope.loading = false;
          $scope.listings = [];
          $scope.listingRows = [];
          $scope.manualSearch = false;
          $scope.dataLoaded = true;
          if (e.status === 400) {
            $scope.errorMessage = `Search query is invalid`;
          } else {
            $scope.errorMessage = 'Error from server';
          }
          $scope.totalListings = count;
        });
    });
  }

  $scope.$on('$destroy', function () {
    resetShape();
  });

  // utilities
  var getStyle = function (status) {
    return status.toLowerCase().replace(new RegExp(' ', 'g'), '_');
  };

  $scope.getLastPage = function () {
    return Math.ceil($scope.totalListings / $scope.pageSize);
  };

  $scope.bedOptions = [
    {
      label: 'Any',
      value: 0,
    },
    {
      label: 1,
      value: 1,
    },
    {
      label: 2,
      value: 2,
    },
    {
      label: 3,
      value: 3,
    },
    {
      label: 4,
      value: 4,
    },
    {
      label: 5,
      value: 5,
    },
    {
      label: '6+',
      value: 6,
    },
  ];

  $scope.bathOptions = [
    {
      label: 'Any',
      value: 0,
    },
    {
      label: 1,
      value: 1,
    },
    {
      label: 2,
      value: 2,
    },
    {
      label: 3,
      value: 3,
    },
    {
      label: '4+',
      value: 4,
    },
  ];

  $scope.statuses = [
    'All',
    'Assignment',
    'Coming Soon',
    'Exclusive',
    'New Construction',
  ];

  $scope.subtypes = ['All', 'Lease', 'Sale'];

  $scope.types = ['All', 'freehold', 'condo', 'commercial'];
}
